export const EXAMPLE_FORM = 'EXAMPLE_FORM';
export const ATTENDEE_VISIBILITY_FORM = 'ATTENDEE_VISIBILITY_FORM';
export const ATTENDEE_REVIEW_FORM = 'ATTENDEE_REVIEW_FORM';
export const ADD_ITEMS_FORM = 'ADD_ITEMS_FORM';
export const CREATE_ITEM_FORM = 'CREATE_ITEM_FORM';
export const ADDTL_TAX_FEES_FORM = 'ADDTL_TAX_FEES_FORM';
export const ADD_ITEM_FORM = 'ADD_ITEM_FORM';
export const SEND_OFFER_FORM = 'SEND_OFFER_FORM';
